<template>
  <div 
    class="floating-btn"
    :style="{ 
      left: positionX + 'px',
      bottom: positionY + 'px'
    }"
    @mousedown="startDrag"
    @touchstart="startDrag"
  >
    <img src="../assets/telegram.gif" style="width: 66px; height: auto;" alt="懸浮按鈕">
  </div>
</template>

<script>
export default {
  name: 'FloatingButton',
  data() {
    return {
      positionX: 30,    // 默認值會被mounted覆蓋
      positionY: 30,
      isDragging: false,
      startX: 0,
      startY: 0
    }
  },
  mounted() {
    // 組件掛載時加載保存的位置
    this.loadPosition()
  },
  methods: {
    // 加載本地存儲的位置
    loadPosition() {
      try {
        const savedPos = localStorage.getItem('floatingBtnPos')
        if (savedPos) {
          const { x, y } = JSON.parse(savedPos)
          const maxX = window.innerWidth - 66
          const maxY = window.innerHeight - 66
          
          // 邊界檢查，確保加載的位置在可視範圍內
          this.positionX = Math.max(0, Math.min(x, maxX))
          this.positionY = Math.max(0, Math.min(y, maxY))
          return
        }
      } catch (e) {
        console.warn('讀取懸浮按鈕位置失敗:', e)
      }
      // 默認位置：右下角
      this.positionX = window.innerWidth - 66 - 30
      this.positionY = 30
    },
    startDrag(e) {
      this.isDragging = true
      const clientX = e.clientX || e.touches[0].clientX
      const clientY = e.clientY || e.touches[0].clientY
      
      // 計算初始點擊點相對於元素左上角的坐標
      this.startX = clientX - this.positionX
      this.startY = clientY - (window.innerHeight - this.positionY - 66) // 修正Y坐標計算

      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
      document.addEventListener('touchmove', this.onDrag)
      document.addEventListener('touchend', this.stopDrag)
    },
    onDrag(e) {
      if (!this.isDragging) return
      
      const clientX = e.clientX || e.touches[0].clientX
      const clientY = e.clientY || e.touches[0].clientY
      
      // 計算新坐標
      const newX = clientX - this.startX
      const newY = window.innerHeight - (clientY - this.startY) - 66 // 轉換為bottom定位

      // 邊界限制
      const maxX = window.innerWidth - 66
      const maxY = window.innerHeight - 66
      
      this.positionX = Math.max(0, Math.min(newX, maxX))
      this.positionY = Math.max(0, Math.min(newY, maxY))
    },
    // 保存位置到本地存儲
    savePosition() {
      const position = {
        x: this.positionX,
        y: this.positionY
      }
      localStorage.setItem('floatingBtnPos', JSON.stringify(position))
    },
    stopDrag() {
      // 拖動結束後保存位置
      this.savePosition()


      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
      document.removeEventListener('touchmove', this.onDrag)
      document.removeEventListener('touchend', this.stopDrag)
    }
  }
}
</script>

<style scoped>
.floating-btn {
  position: fixed;
  cursor: move;
  touch-action: none;
}
</style>
